<script setup lang="ts">
import { ref } from 'vue'

import { useVideoControls } from '@internal/composables'
import type { MediaItem } from '@storefront-satch/components/molecules/gallery/types'
import cn from 'internal/tailwind-classmerge'

import { PauseIcon, PlayIcon } from '@fond-of/satch-icons'

const props = withDefaults(
  defineProps<{
    item: MediaItem
    isActive: boolean
    play?: boolean
    videoClass?: string
    videoPreload?: 'auto' | 'none' | 'metadata'
  }>(),
  {
    videoClass: '',
    videoPreload: 'none',
  }
)

const emit = defineEmits<{
  play: [void]
  pause: [void]
}>()

const videoElement = ref<HTMLVideoElement | null>(null)
const { isPlaying, playPauseVideo } = useVideoControls(
  videoElement,
  props,
  emit
)
</script>

<template>
  <div class="relative h-fit cursor-pointer">
    <video
      ref="videoElement"
      data-chromatic="ignore"
      data-object-fit="cover"
      loop
      muted
      playsinline
      :preload="videoPreload"
      :class="videoClass"
      @click="playPauseVideo"
    >
      <source
        :src="item.url"
        type="video/mp4"
      />
    </video>
    <!-- controls -->
    <div
      :class="
        cn(
          'text-primary absolute bottom-7 right-4 z-10 flex h-12 w-12 translate-x-full transform cursor-pointer flex-col flex-wrap items-center justify-center gap-1 text-center opacity-100 transition-transform duration-300 md:bottom-0 md:right-0 md:h-20 md:w-20',
          { 'translate-x-0': isActive },
          {
            'opacity-0 transition-opacity delay-[2s] duration-1000 ease-out':
              isActive && isPlaying,
          }
        )
      "
      @click="playPauseVideo"
    >
      <component
        :is="isPlaying ? PauseIcon : PlayIcon"
        :class="cn('text-primary h-9 w-9', isPlaying == false && '')"
      />
    </div>
    <!-- controlsEnd -->
  </div>
</template>
